(function () {
  function imageCollection() {
    this.imagecontainer = $('.submenu-wrap.open').find(
      '.image-wrap .image_menu_container',
    );
    this.init = function (obj) {
      var urlImage = obj.dataset.image;
      if (urlImage) {
        this.imagecontainer.css('background-image', 'url(' + urlImage + ')');
        $('.submenu-wrap.open .image_menu').attr('src', urlImage);
      }
    };
  }

  function openChild() {
    this.init = function (obj) {
      this.selectCurrent($(obj));
      this.openCurrent(obj);
    };

    this.selectCurrent = function (obj) {
      var currentParentElemnt = obj.parent().parent();
      currentParentElemnt.find('.submenu_link').each(function () {
        $(this).removeClass('current');
      });
      obj.addClass('current');
    };

    this.openCurrent = function (obj) {
      var childSector = obj.dataset.sector;
      var dataChild = obj.dataset.child;
      var dataParent = obj.dataset.parent;

      //clear parent
      if (!dataParent) {
        $('.linktoactive').each(function () {
          var cDataParent = this.dataset.parent;
          if (cDataParent) {
            $(this).addClass('hide');
            $(this).removeClass('current');
          }
        });
        $('.submenu.submenu_lvl2').addClass('invisible');
      }

      if (childSector) {
        var sectorChildDiv = $('.' + childSector);
        var findChild = false;
        sectorChildDiv.find('.submenu_link').each(function () {
          if (!$(this).hasClass('hide')) $(this).addClass('hide');
          var cDataParent = this.dataset.parent;
          if (dataChild === cDataParent && dataChild != undefined) {
            findChild = true;
            $(this).removeClass('hide');
          }
        });
        if (findChild) {
          sectorChildDiv.removeClass('invisible');
        } else {
          sectorChildDiv.addClass('invisible');
        }
      }
    };
  }

  $('.submenu_link').on('mouseenter mouseleave', function () {
    var menu_mobile = 1375;
    if (jQuery(window).outerWidth(true) > menu_mobile) {
      new imageCollection().init(this);
      new openChild().init(this);
    }
  });
})();
